
import { IEmployee, IOwner, IFileId, IIngredient, IBranch, ISponsor, IMenu } from './../../interfaces/index';
import { IUserProfile, IAccount, ILanguage, ICurrency } from '@/interfaces';
import { MainState, AppNotification } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { AxiosError } from 'axios';
import { indexOfCb } from '@/utils';


export const mutations = {
    setToken(state: MainState, payload: string) {
        state.token = payload;
    },
    setLoggedIn(state: MainState, payload: boolean) {
        state.isLoggedIn = payload;
    },
    setLogInError(state: MainState, payload: boolean) {
        state.logInError = payload;
    },
    setLoginErrorCause(state: MainState, payload: AxiosError | any) {
        const err = payload as AxiosError;
        err.code
        const response_data = err.response?.data;
        const browserLocale = navigator.language?.split('-')[0];
        
        if(response_data){
            const detail = (response_data as any).detail;
            if(detail){
                if(detail[browserLocale]){
                    state.logInErrorCause = detail[browserLocale];
                } else {
                    state.logInErrorCause = detail.en;
                }
            }
            
        } 
        
        if(!state.logInErrorCause){
            state.logInErrorCause = `${err.code} ${err.message}`;  
        } 
    }, 
    setUserProfile(state: MainState, payload: IUserProfile) {
        state.userProfile = payload;
    },
    setDashboardMiniDrawer(state: MainState, payload: boolean) {
        state.dashboardMiniDrawer = payload;
    },
    setDashboardShowDrawer(state: MainState, payload: boolean) {
        state.dashboardShowDrawer = payload;
    },
    addNotification(state: MainState, payload: AppNotification) {
        state.notifications.push(payload);
    },
    removeNotification(state: MainState, payload: AppNotification) {
        state.notifications = state.notifications.filter((notification) => notification !== payload);
    },
    setUserPhoto(state: MainState, payload) {
        console.log(payload);
        try {
            const myReader = new FileReader();
            myReader.onload = () => {
                // state.userPhotoProfile = `data:;base64,${reader.result}`;
                state.userPhotoProfile = myReader.result;
            };
            myReader.onerror = (error) => {
                // console.log('Error: ', error);
            };
            myReader.readAsDataURL(payload);
        } catch (e) {
            // console.log('Error', e);
        }
    },
    setSelectedAccount(state: MainState, account: number) {
        state.selected_account = account;
    },
    setEmployeeProfile(state: MainState, payload: IEmployee) {
        state.employeeProfile = payload;
    },
    setOwnerProfile(state: MainState, payload: IOwner) {
        state.ownerProfile = payload;
    },
    setSelectedBranch(state: MainState, branch_id: number) {
        state.selectedBranch = branch_id;
    },
    updateUploadedMediaList(state: MainState, fileId: IFileId){
        state.mediaUploaded.push(fileId);
    },
    updateUploadedMediaList2(state: MainState, fileId: IFileId[]){
        fileId.forEach(f => {
            state.mediaUploaded.push(f);
        })
        
    },
    clearUploadMediaList(state: MainState){
        state.mediaUploaded= [];
    },
    setCurrentAccount(state: MainState, payload: IAccount){
        state.currentAccount = payload;
    },
    setIngredients(state: MainState, payload: IIngredient[]){
        state.ingredients = payload;
    },
    setIngredient(state: MainState, payload: IIngredient){
        let index = indexOfCb(state.ingredients, (ingredient: IIngredient) => {
            return ingredient.id == payload.id
        });
        if(index >= 0){
            state.ingredients[index] = payload;
        } else {
            state.ingredients.push(payload);
        }
    },
    setAutocompleteIngredients(state: MainState, payload: IIngredient[]){
        state.autoCompleteIngredients = payload;
    },
    setDefaultLanguage(state: MainState, payload: ILanguage) {
        state.defaultLanguage = payload;
    },
    setDefaultCurrency(state: MainState, payload: ICurrency) {
        state.defaultCurrency = payload;
    },
    setCurrentSelectedBranch(state: MainState, payload: IBranch | null | undefined) {
        state.currentSelectedBranch = payload;
    },
    showOverlayLoadingIndicator(state: MainState) {
        state.showOverlayLoadingIndicator = true;
    },
    hideOverlayLoadingIndicator(state: MainState) {
        state.showOverlayLoadingIndicator = false;
    },
    setCurrentSponsor(state: MainState, payload: ISponsor) {
        state.currentSponsor = payload;
    },

    setAccountMenu(state: MainState, payload: IMenu) {
        if(state.currentAccount){
            state.currentAccount.menu = payload;
        }
    }

};

const {commit} = getStoreAccessors<MainState | any, State>('');

export const commitSetDashboardMiniDrawer = commit(mutations.setDashboardMiniDrawer);
export const commitSetDashboardShowDrawer = commit(mutations.setDashboardShowDrawer);
export const commitSetLoggedIn = commit(mutations.setLoggedIn);
export const commitSetLogInError = commit(mutations.setLogInError);
export const commitSetToken = commit(mutations.setToken);
export const commitSetUserProfile = commit(mutations.setUserProfile);
export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);
export const commitSetUserPhoto = commit(mutations.setUserPhoto);
export const commitSetSelectedAccount = commit(mutations.setSelectedAccount);
export const commitSetEmployeeProfile = commit(mutations.setEmployeeProfile);
export const commitSetOwnerProfile = commit(mutations.setOwnerProfile);
export const commitSetSelectedBranch = commit(mutations.setSelectedBranch);
export const commitUpdateUploadedMediaList = commit(mutations.updateUploadedMediaList);
export const commitClearUploadMediaList = commit(mutations.clearUploadMediaList);
export const commitSetCurrentAccount = commit(mutations.setCurrentAccount);
export const commitUpdateUploadedMediaList2 = commit(mutations.updateUploadedMediaList2);
export const commitSetIngredients = commit(mutations.setIngredients);
export const commitSetDefaultLanguage = commit(mutations.setDefaultLanguage);
export const commitSetDefaultCurrency = commit(mutations.setDefaultCurrency);
export const commitSetErrorLoginCause = commit(mutations.setLoginErrorCause);
export const commitSetIngredient = commit(mutations.setIngredient);
export const commitSetAutoCompleteIngredients = commit(mutations.setAutocompleteIngredients);
export const commitSetCurrentSelectedBranch = commit(mutations.setCurrentSelectedBranch);
export const commitShowOverlayLoadingIndicator = commit(mutations.showOverlayLoadingIndicator);
export const commitHideOverlayLoadingIndicator = commit(mutations.hideOverlayLoadingIndicator);
export const commitSetCurrentSponsor = commit(mutations.setCurrentSponsor);
export const commitSetAccountMenu = commit(mutations.setAccountMenu);